/** @format */

import { Component, Input, OnInit } from '@angular/core';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'pdp-personalization-text-input',
    templateUrl: './text-input.component.html',
    styleUrls: ['./text-input.component.scss'],
    standalone: false
})
export class PersonalizationTextInputComponent implements OnInit {
	public TextInputVariants = {
		base: 'base-variant',
		large: 'large-variant'
	};

	@Input()
	public width = '100%';

	@Input()
	public variant = 'base';

	@Input()
	public hasError: boolean;

	@Input()
	public isDisabled: boolean;

	@Input()
	public isRequired: boolean;

	@Input()
	public inputLabel = '';

	@Input()
	public optionalText = '';

	@Input()
	public inlineLabel = '';

	@Input()
	public inputLength: string;

	public attrLabel: string;

	ngOnInit() {
		this.attrLabel = this.getHyphenCaseOfString(this.inputLabel);
	}

	/**
	 * @description Returns the lower and hypen case of a string.
	 */
	private getHyphenCaseOfString(phrase: string): string {
		return phrase.replace(/\s+/g, '-').toLowerCase();
	}
}
